var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { RadioButton } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { ALL_WEEKDAYS, } from "../../types/schedule";
var PARITIES = ["ODD", "EVEN"];
export var BiweeklyEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("div", null,
        React.createElement("h4", null, formatMessage({ id: "ui-br-legaldeposits.schedule.weekday.label" })),
        ALL_WEEKDAYS.map(function (day) { return (React.createElement(RadioButton, { key: day, name: "biweekly-weekday", label: formatMessage({
                id: "ui-br-legaldeposits.schedule.weekday.".concat(day),
            }), checked: value.weekday === day, onChange: function () { return onChange(__assign(__assign({}, value), { weekday: day })); }, disabled: disabled })); }),
        React.createElement("h4", null, formatMessage({ id: "ui-br-legaldeposits.schedule.weekParity.label" })),
        PARITIES.map(function (parity) { return (React.createElement(RadioButton, { key: parity, name: "biweekly-parity", label: formatMessage({
                id: "ui-br-legaldeposits.schedule.weekParity.".concat(parity),
            }), checked: value.weekParity === parity, onChange: function () { return onChange(__assign(__assign({}, value), { weekParity: parity })); }, disabled: disabled })); })));
};
